import { Observer } from 'mobx-react-lite'
import { Form, FormField } from '@/Core/UI/Form'
import { FormRow, FormSection } from '@/Ship/Components/Form/FormSection'
import { UserNameFields } from '@/Containers/SettingSection/UserContainer/Components/UserNameFields'
import { UserPhotoField } from '@/Containers/SettingSection/UserContainer/Components/UserPhotoField'
import { UserPhotoView } from '@/Containers/SettingSection/UserContainer/Components/UserPhotoView'
import { UserStatusField } from '@/Containers/SettingSection/UserContainer/Components/UserStatusField'

// Пароль водію задає адмін у картці співробітника («Змінити пароль»); відновлення з OTP і
// примусової зміни в кабінеті водія немає (рішення замовника 2026-10-28)
export const DriverEditTemplate = ({ formContext }: any) => {
    return (
        <Form formContext={formContext}>
            {/* Фото і статус — як у картці співробітника (ресурс водія успадковує ці поля) */}
            <FormSection>
                <Observer>
                    {() =>
                        formContext.isEditable ? (
                            <UserPhotoField formContext={formContext} />
                        ) : (
                            <UserPhotoView formContext={formContext} />
                        )
                    }
                </Observer>
            </FormSection>

            <Observer>
                {() =>
                    formContext.values?.id > 0 ? (
                        <FormSection>
                            <UserStatusField formContext={formContext} />
                        </FormSection>
                    ) : null
                }
            </Observer>

            <FormSection>
                <UserNameFields formContext={formContext} />
            </FormSection>

            <FormSection>
                <FormRow>
                    <FormField name="phone" />
                    <FormField name="email" />
                    <Observer>
                        {() =>
                            !(formContext.values?.id > 0) ? (
                                // Password is required by the backend on driver create
                                // (user:create: NotNull + NotBlank). The shared UserResource
                                // leaves plainPassword optional because other cards reuse it
                                // without a password — so mark it required only here, via depFn,
                                // which applies to the already-created field at runtime.
                                // depFn is typed `() => boolean` on the FormField prop; cast
                                // to match (same workaround as DepartmentFormTemplate).
                                <FormField
                                    name="plainPassword"
                                    depFn={
                                        (({ field }: { field: { setIsRequired: (v: boolean) => void } }) => {
                                            field.setIsRequired(true)
                                        }) as unknown as () => boolean
                                    }
                                />
                            ) : null
                        }
                    </Observer>
                </FormRow>
            </FormSection>

            <FormSection>
                <FormRow>
                    <FormField name="driverLicenceNumber" />
                    <FormField name="isTrainee" />
                    <FormField name="carrier" />
                    <FormField name="externalCode" />
                </FormRow>
            </FormSection>
        </Form>
    )
}
